import React, { useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createSelector } from 'reselect';
import {Provider as AlertProvider, withAlert} from 'react-alert'

import { getQueryParams } from 'utils/url';

import { ModalTypes } from 'constants/constants';
import AppState from 'store/AppState';
import Routes from 'Routes';
import RouteState from 'store/RouteState';
import UIState, { selectModals, selectToast } from 'store/UIState';
import User, { selectCurrentUser } from 'store/models/User';

import Navbar from 'components/Navbar';
import ModalContainer from 'components/ModalContainer';
import Toast, {ToastDefaults} from 'components/Toast';
import { didPropChange } from 'utils/props';

const withConnect = connect(AppState.selector, AppState.actions);


const selector = createSelector(
  state => state.app,
  selectCurrentUser,
  selectModals,
  selectToast,
  ( viewModel, user, modals, toast) => ({
    ...viewModel,
    modals,
    user,
    toast,
  })
)

const App = ({ alert, match}) => {
  const dispatch = useDispatch();
  const { toast, user, config, } = useSelector(selector);
  let isDev = config?.node_env === 'development'
  let isBeta = config?.node_env === 'beta';
    

  useEffect(() => {
    dispatch(RouteState.actions.setRoute(window.location, match?.params))
  }, []);

  useEffect(() => {
    if(toast)
      alert.show(toast?.message, toast?.options);
  }, [toast])

  
  const onLogin = () => dispatch(UIState.actions.showModal(ModalTypes.LOGIN));
  const onLogout = () => dispatch(User.actions.logoutUser());
  const onSignup = () => dispatch(UIState.actions.showModal(ModalTypes.SIGNUP));

  return (<>
    <ModalContainer />
    <div id="portal-popup" />
    <Navbar 
      user={user}
      onLogin={onLogin}
      onLogout={onLogout}
      onSignup={onSignup} />
    <Routes />
    <div className="app-version">
      {config?.version}
      { isDev ? ` - DEV` : null }
      { isBeta ? ` - BETA` : null }
    </div>
  </>);
}

let addAlert = withAlert();
export default App
  |> withConnect
  |> withRouter
  |> addAlert  

